import React, { Component } from 'react';
import cloneDeep from 'lodash/cloneDeep';
import Modal from '@cloudscape-design/components/modal';
import Input from '@cloudscape-design/components/input';
import Button from '@cloudscape-design/components/button';
import Box from '@cloudscape-design/components/box';
import SpaceBetween from '@cloudscape-design/components/space-between';
import FormField from '@cloudscape-design/components/form-field';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import {
	playerBanEditModalStore,
} from "../stores/playerBanEditModal";
import { Container } from "react-bootstrap";
import Select from "@cloudscape-design/components/select";
import DatePicker from "@cloudscape-design/components/date-picker";

class PlayerBanEditModal extends Component {
	constructor(props) {
		super(props);

		this.state = {
			loading: false,
		}
	}


	resetFormFields = () => {
		const { setPlayerBanEditModal, playerBanEditModal } = this.props;
		setPlayerBanEditModal({
			...playerBanEditModal,
			show: false,
			loaded: false,
			uid: false,
			reason: "",
			banType: false,
			date: false,
			error: {
				text: "",
				code: 0,
				timestamp: 0,
			},
		});
	};

	updateFormField = (key, value) => {
		const { playerBanEditModal, setPlayerBanEditModal } = this.props;
		const updatedState = cloneDeep(playerBanEditModal);
		updatedState[key] = value;
		setPlayerBanEditModal(updatedState);
	};

	editPlayerBan = async () => {
		const { playerBanEditModal, Interface } = this.props;


		try {
			const body = {
				...playerBanEditModal,
				banType: playerBanEditModal?.banType?.value
			};

			this.setState({
				loading: true,
			});

			const result = await Interface.request('set', {
				class: 'data',
				module: 'playerBan',
				method: 'edit',
			}, body);

			Interface.addNoty('Success', 'Player ban edit successfully');
			Interface.loadPlayerBan();
			this.resetFormFields();
		} catch (error) {
			Interface.addNoty('Error', error.text || error.toString());
		} finally {
			this.setState({
				loading: false,
			});
		}
	};

	render() {
		const { playerBanEditModal, setPlayerBanEditModal } = this.props;

		return (
			<Modal
				visible={playerBanEditModal.show}
				size="medium"
				onDismiss={() => setPlayerBanEditModal({ ...playerBanEditModal, show: false })}
				header="Add Player ban"
				footer={
					<Box float="right">
						<SpaceBetween direction="horizontal" size="xs">
							<Button variant="normal" onClick={this.resetFormFields}>
								Cancel
							</Button>
							<Button disabled={this.state.loading} loading={this.state.loading} variant="primary" onClick={this.editPlayerBan}>
								Save
							</Button>
						</SpaceBetween>
					</Box>
				}
			>
				<Container>
					<SpaceBetween direction="vertical" size="m">
						<FormField
							label="Uid"
							description="User uid"
							stretch
						>
							<Input
								type="number"
								value={playerBanEditModal.uid}
								onChange={({ detail }) =>
									this.updateFormField("uid", detail.value)
								}
								placeholder="1"
								inputMode="numeric"
							/>
						</FormField>

						<FormField
							label="Reason Required"
							description="Reason translation"
							stretch
						>
							<Input
								type="text"
								value={playerBanEditModal.reason}
								onChange={({ detail }) =>
									this.updateFormField(
										"reason",
										detail.value === ""
											? ""
											: detail.value
									)
								}
								placeholder="reason"
								inputMode="text"
							/>
						</FormField>
						<FormField label="Select ban type"
											 stretch>
							<Select
								filteringType="auto"
								placeholder="Ban type"
								selectedOption={playerBanEditModal.banType}
								onChange={({ detail }) => this.updateFormField("banType", detail.selectedOption)}
								options={[{ value: "forbidden", label: "Forbidden" }, { value: "date", label: "Date" }]}
								stretch
							/>
						</FormField>
						{playerBanEditModal.banType?.value === "date" && <FormField
							label="Till"
							description="Ban till"
							stretch
						>
							<DatePicker
								onChange={({ detail }) => this.updateFormField("date", detail.value)}
								value={playerBanEditModal.date}
								openCalendarAriaLabel={selectedDate =>
									"Choose certificate expiry date" +
									(selectedDate
										? `, selected date is ${selectedDate}`
										: "")
								}
								placeholder="YYYY/MM/DD"
								nextMonthAriaLabel={""} previousMonthAriaLabel={""} todayAriaLabel={""}/>
						</FormField>}

					</SpaceBetween>
				</Container>
			</Modal>
		);
	}
}

function withRecoil(Component) {
	return function WrappedComponent(props) {
		const playerBanEditModal = useRecoilValue(playerBanEditModalStore);
		const setPlayerBanEditModal = useSetRecoilState(playerBanEditModalStore);

		return (
			<Component
				{...props}
				setPlayerBanEditModal={setPlayerBanEditModal}
				playerBanEditModal={playerBanEditModal}
			/>
		);
	};
}

export default withRecoil(PlayerBanEditModal);